/* istanbul ignore file */

export const DESIGN_CONSTANTS = {
    DIALOG_WIDTH_1136PX: '1136px',
    DIALOG_WIDTH_700PX: '700px',
    DIALOG_STEPPER_WIDTH: '960px',
    DIALOG_STANDARD_WIDTH: '560px',
    DIALOG_CONFIRMATION_WIDTH: '450px',
    SCROLL_TO_MAP_FIELD_OFFSET: 275,
    DONUT_INNER_RADIUS_RATIO: 0.6,
    PHOTO_GALLERY_DEFAULT_HEIGHT: '500px',
    ACTIONS_GRID_COLUMN_WIDTH: 80
};

export const DESIGN_FIELD_NAME_CONSTANTS = {
    DATE_CREATED: 'dateCreated',
    SUBSCRIPTION_START_DATE: 'subscriptionStartDate',
    SUBSCRIPTION_END_DATE: 'subscriptionEndDate'
};
